<template>
  <div
    class="whatsapp-bubble"
    :class="{'whatsapp-bubble--above-footer': footerVisible}"
  >
    <v-card
      v-if="expanded"
      class="whatsapp-bubble__card mb-2"
      elevation="8"
    >
      <v-card-text class="pb-2">
        <v-row class="ma-0 align-start flex-nowrap">
          <span class="fab fa-whatsapp whatsapp-bubble__card-icon mr-3"/>
          <span class="whatsapp-bubble__text">{{$t('v16.whatsAppCommunityText')}}</span>
          <v-btn
            icon
            small
            class="ml-2 mt-n1"
            :aria-label="$t('v16.whatsAppCommunityCollapse')"
            :title="$t('v16.whatsAppCommunityCollapse')"
            @click="collapse()"
          >
            <span class="fal fa-times"/>
          </v-btn>
        </v-row>
      </v-card-text>

      <v-card-actions class="pt-0">
        <v-btn
          block
          color="primary"
          outlined
          :href="communityUrl"
          target="_blank"
          rel="noopener noreferrer"
        >
          <span class="fab fa-whatsapp mr-2"/>
          {{$t('v16.whatsAppCommunityJoin')}}
        </v-btn>
      </v-card-actions>
    </v-card>
    <div class="text-right">
      <v-btn
        fab
        dark
        class="whatsapp-bubble__fab"
        :aria-label="$t('v16.whatsAppCommunityAria')"
        :title="$t('v16.whatsAppCommunityAria')"
        @click="toggle()"
      >
        <span class="fab fa-whatsapp whatsapp-bubble__fab-icon"/>
      </v-btn>
    </div>
  </div>
</template>

<script>
  const COMMUNITY_URL = 'https://chat.whatsapp.com/KzGFIWoMiaeDAMe436rWEh'
  const COLLAPSED_LS_KEY = 'whatsapp-community-bubble-v1'

  export default {
    name: 'WhatsAppBubble',

    props: {
      footerVisible: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        communityUrl: COMMUNITY_URL,
        expanded: !this.hasBeenCollapsed()
      }
    },

    methods: {
      hasBeenCollapsed () {
        try {
          return window.localStorage.getItem(COLLAPSED_LS_KEY) === 'collapsed'
        } catch (error) {
          return true
        }
      },

      collapse () {
        this.expanded = false
        try {
          window.localStorage.setItem(COLLAPSED_LS_KEY, 'collapsed')
        } catch (error) {
          this.expanded = false
        }
      },

      toggle () {
        if (this.expanded) {
          this.collapse()
        } else {
          this.expanded = true
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .whatsapp-bubble {
    position: fixed;
    right: 16px;
    bottom: 16px;
    z-index: 6;
  }
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .whatsapp-bubble--above-footer {
      bottom: $s-footer-mobile + 16px;
    }
  }

  .whatsapp-bubble__card {
    max-width: 300px;
  }

  .whatsapp-bubble__text {
    font-size: 0.875rem;
    line-height: 1.3;
  }

  .whatsapp-bubble__card-icon {
    color: #25d366;
    font-size: 1.25rem;
  }
  .whatsapp-bubble__fab {
    background-color: #25d366 !important;
  }

  .whatsapp-bubble__fab-icon {
    font-size: 1.75rem;
  }
</style>
